import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_FRIEND_DATA,
  SET_VIEW_FRIEND_DATA,
  SET_VIEW_FRIEND_DATA_FAIL,
  SET_SELECTED_FRIEND,
  INITIATE_VIEW_FRIEND_REMARKS_DATA,
  SET_VIEW_FRIEND_REMARKS_DATA,
  SET_VIEW_FRIEND_REMARKS_DATA_FAIL,
  SET_FRIEND_SEARCH_QUERY,
  INITIATE_PENDING_TRANSFER_FRIEND_DATA,
  SET_PENDING_TRANSFER_FRIEND_DATA,
  SET_PENDING_TRANSFER_FRIEND_DATA_FAIL,
  SET_SELECTED_PENDING_TRANSFER_FRIEND,
  SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS,
  SET_SELECTED_INTRODUCTION_FROM_SEARCH,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  lastSearchQuery: "",
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
  selectedFriend: {
    remarks: {
      data: [],
      isLoading: false,
      error: null,
    },
  },
  pendingTransfer: {
    data: [],
    isLoading: false,
    error: null,
    paginationInfo: {
      currentPage: 0,
      totalPages: 1,
      totalElements: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    },
  },
  selectedPendingTransfer: {
    remarks: {
      data: [],
      isLoading: false,
      error: null,
    },
  },
  selectedIntroductionFromSearch: {},
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_FRIEND_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_VIEW_FRIEND_DATA:
      return {
        ...state,
        data: payload.data,
        paginationInfo: payload?.paginationInfo,
        isLoading: false,
      };
    case SET_FRIEND_SEARCH_QUERY:
      return {
        ...state,
        lastSearchQuery: payload,
      };
    case SET_VIEW_FRIEND_DATA_FAIL:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: payload,
      };

    case SET_SELECTED_FRIEND:
      return {
        ...state,
        selectedFriend: {
          ...state.selectedFriend,
          ...payload,
        },
      };

    case INITIATE_VIEW_FRIEND_REMARKS_DATA:
      return {
        ...state,
        selectedFriend: {
          ...state.selectedFriend,
          remarks: {
            isLoading: true,
            data: [],
            error: null,
          },
        },
      };

    case SET_VIEW_FRIEND_REMARKS_DATA:
      return {
        ...state,
        selectedFriend: {
          ...state.selectedFriend,
          remarks: {
            data: payload,
            isLoading: false,
            error: null,
          },
        },
      };

    case SET_VIEW_FRIEND_REMARKS_DATA_FAIL:
      return {
        ...state,
        selectedFriend: {
          ...state.selectedFriend,
          remarks: {
            isLoading: false,
            data: [],
            error: payload,
          },
        },
      };

    case INITIATE_PENDING_TRANSFER_FRIEND_DATA:
      return {
        ...state,
        pendingTransfer: { ...state.pendingTransfer, isLoading: true },
      };

    case SET_PENDING_TRANSFER_FRIEND_DATA:
      return {
        ...state,
        pendingTransfer: {
          ...payload,
          isLoading: false,
          error: null,
        },
      };

    case SET_PENDING_TRANSFER_FRIEND_DATA_FAIL:
      return {
        ...state,
        pendingTransfer: {
          ...state.pendingTransfer,
          data: {},
          paginationInfo: payload?.paginationInfo,
          isLoading: false,
          error: action.payload,
        },
      };

    case SET_SELECTED_PENDING_TRANSFER_FRIEND:
      return {
        ...state,
        selectedPendingTransfer: {
          ...state.selectedPendingTransfer,
          ...action.payload,
        },
      };

    case SET_SELECTED_PENDING_TRANSFER_FRIEND_REMARKS:
      return {
        ...state,
        selectedPendingTransfer: {
          ...state.selectedPendingTransfer,
          remarks: {
            data: payload,
          },
        },
      };

    case SET_SELECTED_INTRODUCTION_FROM_SEARCH:
      return {
        ...state,
        selectedIntroductionFromSearch: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
